import { useCallback } from 'react';
import { useDeleteCustomLabelMutation } from 'graphql/types';

type DeleteCustomLabelReturn = {
  loading: boolean;
  deleteCustomLabel: (id: string) => Promise<string | undefined>;
};
export const useDeleteCustomLabel = (
  onComplete?: () => void
): DeleteCustomLabelReturn => {
  const [
    deleteCustomLabelMutation,
    { loading }
  ] = useDeleteCustomLabelMutation();

  const deleteCustomLabel = useCallback(
    async (id: string) => {
      const result = await deleteCustomLabelMutation({
        variables: {
          input: {
            id
          }
        },
        refetchQueries: ['labels'],
        awaitRefetchQueries: true
      });
      onComplete?.();
      return result.data?.deleteCustomLabel.id;
    },
    [deleteCustomLabelMutation, onComplete]
  );

  return { loading, deleteCustomLabel };
};
